<template>
  <div>
    <div class="customer">{{ item.customer.name }}</div>
    <div class="contacts">
      <a
        v-for="contact in item.contacts"
        class="cursor-pointer"
        :key="contact.id"
        @click="showContact(contact)"
      >
        <i class="far fa-circle-user" />
        {{ displayName(contact) }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-customer",
  props: {
    item: Object,
    options: Object,
  },
  computed: {
    displayName() {
      return function (contact) {
        if (this.item.contacts.length == 1) return contact.name;
        else return contact.name.split(/\s|@/)[0];
      };
    },
  },
  methods: {
    showContact(contact) {
      Dialog.open({
        componentPath: "pages/contacts/profile",
        width: "750px",
        pivotX: 1,
        pivotY: 0,
        clickToClose: true,
        user: {
          ...contact,
          companies: [this.item.customer.name],
          remindable: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  @apply tracking-tighter leading-3;
}
.contacts {
  @apply text-2xs flex items-center place-self-center gap-0.5;
}
</style>
